/* eslint-disable camelcase */
import voice1No from 'assets/sounds/nn/sprak/lower/sf-test-1.mp3';
import voice2No from 'assets/sounds/nn/sprak/lower/sf-test-2.mp3';
import voice3No from 'assets/sounds/nn/sprak/lower/sf-test-3.mp3';
import voice4No from 'assets/sounds/nn/sprak/lower/sf-test-4.mp3';
import voice5No from 'assets/sounds/nn/sprak/lower/sf-test-5.mp3';
import voice6No from 'assets/sounds/nn/sprak/lower/sf-test-6.mp3';
import voice7No from 'assets/sounds/nn/sprak/lower/sf-test-7.mp3';
import voice8No from 'assets/sounds/nn/sprak/lower/sf-test-8.mp3';
import voice9No from 'assets/sounds/nn/sprak/lower/sf-test-9.mp3';
import voice10No from 'assets/sounds/nn/sprak/lower/sf-test-10.mp3';
import voice11No from 'assets/sounds/nn/sprak/lower/sf-test-11.mp3';
import voice12No from 'assets/sounds/nn/sprak/lower/sf-test-12.mp3';
import voice13No from 'assets/sounds/nn/sprak/lower/sf-test-13.mp3';
import voice14No from 'assets/sounds/nn/sprak/lower/sf-test-14.mp3';
import voice15No from 'assets/sounds/nn/sprak/lower/sf-test-15.mp3';
import voice16No from 'assets/sounds/nn/sprak/lower/sf-test-16.mp3';
import voice17No from 'assets/sounds/nn/sprak/lower/sf-test-17.mp3';
import voice18No from 'assets/sounds/nn/sprak/lower/sf-test-18.mp3';
import voice19No from 'assets/sounds/nn/sprak/lower/sf-test-18.mp3';

import testImg1_1 from '../assets/TestImagesLower/test1_1.png';
import testImg1_2 from '../assets/TestImagesLower/test1_2.png';
import testImg1_3 from '../assets/TestImagesLower/test1_3.png';
import testImg1_4 from '../assets/TestImagesLower/test1_4.png';

import testImg2_1 from '../assets/TestImagesLower/test2_1.png';
import testImg2_2 from '../assets/TestImagesLower/test2_2.png';
import testImg2_3 from '../assets/TestImagesLower/test2_3.png';
import testImg2_4 from '../assets/TestImagesLower/test2_4.png';

import testImg3_1 from '../assets/TestImagesLower/test3_1.png';
import testImg3_2 from '../assets/TestImagesLower/test3_2.png';
import testImg3_3 from '../assets/TestImagesLower/test3_3.png';
import testImg3_4 from '../assets/TestImagesLower/test3_4.png';

import testImg4_1 from '../assets/TestImagesLower/test4_1.png';
import testImg4_2 from '../assets/TestImagesLower/test4_2.png';
import testImg4_3 from '../assets/TestImagesLower/test4_3.png';
import testImg4_4 from '../assets/TestImagesLower/test4_4.png';

import testImg5_1 from '../assets/TestImagesLower/test5_1.png';
import testImg5_2 from '../assets/TestImagesLower/test5_2.png';
import testImg5_3 from '../assets/TestImagesLower/test5_3.png';
import testImg5_4 from '../assets/TestImagesLower/test5_4.png';

import testImg6_1 from '../assets/TestImagesLower/test6_1.png';
import testImg6_2 from '../assets/TestImagesLower/test6_2.png';
import testImg6_3 from '../assets/TestImagesLower/test6_3.png';
import testImg6_4 from '../assets/TestImagesLower/test6_4.png';

import testImg7_1 from '../assets/TestImagesLower/test7_1.png';
import testImg7_2 from '../assets/TestImagesLower/test7_2.png';
import testImg7_3 from '../assets/TestImagesLower/test7_3.png';
import testImg7_4 from '../assets/TestImagesLower/test7_4.png';

import testImg8_1 from '../assets/TestImagesLower/test8_1.png';
import testImg8_2 from '../assets/TestImagesLower/test8_2.png';
import testImg8_3 from '../assets/TestImagesLower/test8_3.png';
import testImg8_4 from '../assets/TestImagesLower/test8_4.png';

import testImg9_1 from '../assets/TestImagesLower/test9_1.png';
import testImg9_2 from '../assets/TestImagesLower/test9_2.png';
import testImg9_3 from '../assets/TestImagesLower/test9_3.png';
import testImg9_4 from '../assets/TestImagesLower/test9_4.png';

import testImg10_1 from '../assets/TestImagesLower/test10_1.png';
import testImg10_2 from '../assets/TestImagesLower/test10_2.png';
import testImg10_3 from '../assets/TestImagesLower/test10_3.png';
import testImg10_4 from '../assets/TestImagesLower/test10_4.png';

import testImg11_1 from '../assets/TestImagesLower/test11_1.png';
import testImg11_2 from '../assets/TestImagesLower/test11_2.png';
import testImg11_3 from '../assets/TestImagesLower/test11_3.png';
import testImg11_4 from '../assets/TestImagesLower/test11_4.png';

import testImg12_1 from '../assets/TestImagesLower/test12_1.png';
import testImg12_2 from '../assets/TestImagesLower/test12_2.png';
import testImg12_3 from '../assets/TestImagesLower/test12_3.png';
import testImg12_4 from '../assets/TestImagesLower/test12_4.png';

import testImg13_1 from '../assets/TestImagesLower/test13_1.png';
import testImg13_2 from '../assets/TestImagesLower/test13_2.png';
import testImg13_3 from '../assets/TestImagesLower/test13_3.png';
import testImg13_4 from '../assets/TestImagesLower/test13_4.png';

import testImg14_1 from '../assets/TestImagesLower/test14_1.png';
import testImg14_2 from '../assets/TestImagesLower/test14_2.png';
import testImg14_3 from '../assets/TestImagesLower/test14_3.png';
import testImg14_4 from '../assets/TestImagesLower/test14_4.png';

import testImg15_1 from '../assets/TestImagesLower/test15_1.png';
import testImg15_2 from '../assets/TestImagesLower/test15_2.png';
import testImg15_3 from '../assets/TestImagesLower/test15_3.png';
import testImg15_4 from '../assets/TestImagesLower/test15_4.png';

import testImg16_1 from '../assets/TestImagesLower/test16_1.png';
import testImg16_2 from '../assets/TestImagesLower/test16_2.png';
import testImg16_3 from '../assets/TestImagesLower/test16_3.png';
import testImg16_4 from '../assets/TestImagesLower/test16_4.png';

import testImg17_1 from '../assets/TestImagesLower/test17_1.png';
import testImg17_2 from '../assets/TestImagesLower/test17_2.png';
import testImg17_3 from '../assets/TestImagesLower/test17_3.png';
import testImg17_4 from '../assets/TestImagesLower/test17_4.png';

import testImg18_1 from '../assets/TestImagesLower/test18_1.png';
import testImg18_2 from '../assets/TestImagesLower/test18_2.png';
import testImg18_3 from '../assets/TestImagesLower/test18_3.png';
import testImg18_4 from '../assets/TestImagesLower/test18_4.png';

import starterTesten from 'assets/sounds/no/3 13 Tulleord Starter testen.mp3';

export const starterTestenSound = starterTesten;


export const bytteLydenExample = {};

export const tutorialAssignment = {
	id: 1,
	choices: [
		{
			word: 'lys',
		},
		{
			word: 'lese',
		},
		{
			word: 'katt',
		},
		{
			isCorrect: true,
			word: 'kam',
		},
	],
};
export const assignment1 = [
	{
		id: 1,
		mainimg: '',
		mainSound: voice1No,
		order:['d'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg1_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg1_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg1_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg1_4,
			},
		]}
		],
	},
];
export const assignment2 = [
	{
		id: 2,
		mainImg: '',
		mainSound: voice2No,
		order:['a'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg2_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg2_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg2_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg2_4,
			},
		]}
		],
	},
];
export const assignment3 = [
	{
		id: 3,
		mainImg: '',
		mainSound: voice3No,
		order:['c'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg3_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg3_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg3_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg3_4,
			},
		]}
		],
	},
];
export const assignment4 = [
	{
		id: 4,
		mainImg: '',
		mainSound: voice4No,
		order:['d'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg4_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg4_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg4_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg4_4,
			},
		]}
		],
	},
];
export const assignment5 = [
	{
		id: 5,
		mainImg: '',
		mainSound: voice5No,
		order:['b'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg5_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg5_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg5_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg5_4,
			},
		]}
		],
	},
];
export const assignment6 = [
	{
		id: 6,
		mainImg: '',
		mainSound: voice6No,
		order:['c'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg6_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg6_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg6_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg6_4,
			},
		]}
		],
	},
];
export const assignment7 = [
	{
		id: 7,
		mainImg: '',
		mainSound: voice7No,
		order:['c'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg7_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg7_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg7_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg7_4,
			},
		]}
		],
	},
];
export const assignment8 = [
	{
		id: 8,
		mainImg: '',
		mainSound: voice8No,
		order:['a'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg8_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg8_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg8_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg8_4,
			},
		]}
		],
	},
];
export const assignment9 = [
	{
		id: 9,
		mainImg: '',
		mainSound: voice9No,
		order:['d'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg9_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg9_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg9_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg9_4,
			},
		]}
		],
	},
];
export const assignment10 = [
	{
		id: 10,
		mainImg: '',
		mainSound: voice10No,
		order:['b'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg10_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg10_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg10_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg10_4,
			},
		]}
		],
	},
];
export const assignment11 = [
	{
		id: 11,
		mainImg: '',
		mainSound: voice11No,
		order:['d'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg11_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg11_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg11_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg11_4,
			},
		]}
		],
	},
];
export const assignment12 = [
	{
		id: 12,
		mainImg: '',
		mainSound: voice12No,
		order:['b'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg12_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg12_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg12_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg12_4,
			},
		]}
		],
	},
];
export const assignment13 = [
	{
		id: 13,
		mainImg: '',
		mainSound: voice13No,
		order:['a'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg13_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg13_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg13_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg13_4,
			},
		]}
		],
	},
];
export const assignment14 = [
	{
		id: 14,
		mainImg: '',
		mainSound: voice14No,
		order:['b'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg14_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg14_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg14_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg14_4,
			},
		]}
		],
	},
];
export const assignment15 = [
	{
		id: 15,
		mainImg: '',
		mainSound: voice15No,
		order:['d'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg15_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg15_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg15_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg15_4,
			},
		]}
		],
	},
];
export const assignment16 = [
	{
		id: 16,
		mainImg: '',
		mainSound: voice16No,
		order:['a'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg16_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg16_2,
				}
				
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg16_3,
			},
			
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg16_4,
			}
		]}
		],
	},
];
export const assignment17 = [
	{
		id: 17,
		mainImg: '',
		mainSound: voice17No,
		order:['c'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg17_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg17_2,
				}
			]
		},
		{choiceGroup:[
			
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg17_3,
			},
			
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg17_4,
			}
		]}
		],
	},
];
export const assignment18 = [
	{
		id: 18,
		mainImg: '',
		mainSound: voice18No,
		order:['a'],
choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					word: 'a',
					img: testImg18_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					word: 'b',
					img: testImg18_2,
				}
				
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				word: 'c',
				img:testImg18_3,
			},
			
			{
				groupId:4,
				currentClass:"illustrationItem",
				word: 'd',
				img: testImg18_4,
			},
		]}
		],
	},
];
export const assignment19 = [
	{
		id: 19,
		mainImg: '',
		mainSound: voice19No,
		text: 'Byt /k/ med /r/',
		choices: [
			{
				word: 'lys',

				img: '',
			},
			{
				word: 'dør',

				img: '',
			},
			{
				word: 'pennal',

				img: '',
			},
			{
				word: 'bord',

				img: '',
			},
		],
	},
];

export const assignments = [
	{
		id: 2,
		mainImg: '',
		choices: [
			{
				word: 'modil',

				img: '',
			},
			{
				word: 'vuks',

				img: '',
			},
			{
				word: 'fålk',

				img: '',
			},
			{
				word: 'flynt',

				img: '',
			},
		],
	},
	{
		id: 3,
		mainimg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},
			{
				word: 'peano',

				img: '',
			},
			{
				word: 'knain',

				img: '',
			},
		],
	},
	{
		id: 4,
		mainImg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},
			{
				word: 'peano',

				img: '',
			},

			{
				word: 'brillter',

				img: '',
			},
		],
	},
	{
		id: 5,
		mainImg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},

			{
				word: 'knain',

				img: '',
			},
			{
				word: 'brillter',

				img: '',
			},
		],
	},
	{
		id: 6,
		mainImg: '',
		choices: [
			{
				word: 'vorr',

				img: '',
			},
			{
				word: 'blastell',

				img: '',
			},

			{
				word: 'knain',

				img: '',
			},
			{
				word: 'brillter',

				img: '',
			},
		],
	},
];
